import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import useMatrixContext from 'contexts/MatrixContext/useMatrixContext';
import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';
import { getWorkspaceRoomIds } from 'modules/Workspaces/WorkspacesProvider/utils';

import { useWebPushContext } from './WebPushContext';

const useWebPushNavigation = () => {
  const { isPushSupported } = useWebPushContext();
  const { workspacesState, setWorkspaceId } = useWorkspacesContext();
  const { matrixClient } = useMatrixContext({ requireDefinedMatrixClient: false });
  const navigate = useNavigate();

  useEffect(() => {
    if (!isPushSupported) return;

    const handler = (event: MessageEvent) => {
      if (event.data?.type !== 'PUSH_NOTIFICATION_CLICK' || !event.data.roomId) return;

      const { roomId } = event.data;

      if (matrixClient) {
        for (const wsId of Object.keys(workspacesState.workspaces)) {
          const roomIds = getWorkspaceRoomIds(matrixClient, wsId);
          if (roomIds?.has(roomId)) {
            setWorkspaceId(wsId);
            break;
          }
        }
      }

      navigate(`/messenger/${roomId}`);
    };

    navigator.serviceWorker.addEventListener('message', handler);
    return () => navigator.serviceWorker.removeEventListener('message', handler);
  }, [isPushSupported, matrixClient, workspacesState, setWorkspaceId, navigate]);
};

const WebPushNavigationHandler = () => {
  useWebPushNavigation();
  return null;
};

export { useWebPushNavigation };
export default WebPushNavigationHandler;
